import React from "react";
import Particles from "react-tsparticles";

function Particle() {
  return (
    <Particles
      id="tsparticles"
      params={{
        particles: {
          number: {
            value: 120,
            density: {
              enable: true,
              value_area: 1500,
            },
          },
          color: {
            value: ["#d4a017", "#f0c040", "#a67c00", "#fbbf24"],
          },
          line_linked: {
            enable: true,
            opacity: 0.08,
            color: "#d4a017",
            distance: 150,
          },
          move: {
            direction: "none",
            speed: 0.4,
            random: true,
          },
          size: {
            value: 2,
            random: true,
          },
          opacity: {
            value: 0.35,
            anim: {
              enable: true,
              speed: 0.8,
              opacity_min: 0.05,
            },
          },
        },
        interactivity: {
          events: {
            onhover: {
              enable: true,
              mode: "grab",
            },
            onclick: {
              enable: true,
              mode: "push",
            },
          },
          modes: {
            grab: {
              distance: 140,
              line_linked: { opacity: 0.3 },
            },
            push: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;
